import { render, staticRenderFns } from "./modal-container.vue?vue&type=template&id=186e4960&scoped=true"
import script from "./modal-container.vue?vue&type=script&lang=js"
export * from "./modal-container.vue?vue&type=script&lang=js"
import style0 from "./modal-container.vue?vue&type=style&index=0&id=186e4960&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186e4960",
  null
  
)

export default component.exports